// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { IconButton } from '../../lib/base';
import { FacebookIcon, LinkedInIcon, XIcon } from '../../lib/icons';

function SocialIconButton({
  icon,
  href,
  title,
}: { readonly icon: React.ReactNode; readonly href: string; readonly title: string }) {
  return (
    <IconButton
      sx={{ color: 'text.primary', border: '1px solid', borderColor: 'text.primary', borderRadius: '50%', p: 1 }}
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={title}
    >
      {icon}
    </IconButton>
  );
}

export function ShareButtons({ title, url }: { title: string; url: string }) {
  return (
    <>
      <SocialIconButton
        icon={<FacebookIcon />}
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        title="Share on Facebook"
      />
      <SocialIconButton
        icon={<XIcon />}
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`}
        title="Share on Twitter"
      />
      <SocialIconButton
        icon={<LinkedInIcon />}
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          url,
        )}&title=${encodeURIComponent(title)}`}
        title="Share on LinkedIn"
      />
    </>
  );
}
